import { service } from '.';

export const externalService = {
  exportConfiguration: ( hookUrl, data, config ) => service().customRequest( 'post', hookUrl, data, config )
};